import React from "react";
import "../../styles/pageNotFound.css";
import { data } from "../../Common/Text/NormalText";

const PageNotFound = () => {
  return (
    <div className="notfound-container">
      <h1 className="error-code">404</h1>
      <p className="error-message">
        {data?.dashOops}
      </p>
      <a href="/login" className="home-link">
        {data?.dash}
      </a>
    </div>
  );
};

export default PageNotFound;
